import React, { useEffect, useState, useRef } from "react";
import StepsHeader from "./components/StepsHeader";
import StepAvailability from "./components/StepAvailability";
import StepBookingDetails from "./components/StepBookingDetails";
import StepSummary from "./components/StepSummary";
import { Link } from "react-router-dom";

const ReservationPage = () => {
  const [step, setStep] = useState(1);
  const [selectedRooms, setSelectedRooms] = useState(null);
  const [guestDetails, setGuestDetails] = useState(null);
  const [filteredRooms, setFilteredRooms] = useState([]);
  const [paymentSummary, setPaymentSummary] = useState(null);
  const maximizeBtnRef = useRef(null);
   const [isFullScreen, setFullScreen] = useState(false);




  // Initialize searchState from localStorage or set defaults
  const [searchState, setSearchState] = useState(() => {
    const savedSearch = localStorage.getItem("searchState");
    const defaultCheckInDate = new Date(); // Today
    const defaultCheckOutDate = new Date();
    defaultCheckOutDate.setDate(defaultCheckOutDate.getDate() + 1); // Tomorrow

    return savedSearch
      ? JSON.parse(savedSearch)
      : {
          bookingSource: "",
          corporateCompany: "",
          rateCard: "",
          checkInDate: defaultCheckInDate.toISOString(),
          checkOutDate: defaultCheckOutDate.toISOString(),
        };
  });



      
useEffect(() => {
  const handleClick = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        console.error("Failed to enter fullscreen:", err);
      });
      setFullScreen(true);
    } else {
      document.exitFullscreen().catch((err) => {
        console.error("Failed to exit fullscreen:", err);
      });
      setFullScreen(false);
    }
  };

  // Listen for fullscreen changes to keep isFullScreen in sync
  const handleFullscreenChange = () => {
    setFullScreen(!!document.fullscreenElement);
  };

  const maximizeBtn = maximizeBtnRef.current;
  if (maximizeBtn) {
    maximizeBtn.addEventListener("click", handleClick);
  }

  // Add fullscreen change listener
  document.addEventListener("fullscreenchange", handleFullscreenChange);

  return () => {
    if (maximizeBtn) {
      maximizeBtn.removeEventListener("click", handleClick);
    }
    document.removeEventListener("fullscreenchange", handleFullscreenChange);
    // Only exit fullscreen if the document is in fullscreen mode
    if (document.fullscreenElement) {
      document.exitFullscreen().catch((err) => {
        console.error("Failed to exit fullscreen during cleanup:", err);
      });
    }
  };
}, []);



  // Load selectedRooms and paymentSummary from localStorage on mount
  useEffect(() => {
    const savedSelectedRooms = localStorage.getItem("selectedRooms");
    const savedBillingSummary = localStorage.getItem("billingSummary");

    if (savedSelectedRooms) {
      setSelectedRooms(JSON.parse(savedSelectedRooms));
    }
    if (savedBillingSummary) {
      setPaymentSummary(JSON.parse(savedBillingSummary));
    }
  }, []);

  // Save searchState to localStorage when it changes
  useEffect(() => {
    localStorage.setItem("searchState", JSON.stringify(searchState));
  }, [searchState]);

  // Dynamically update steps based on current step
  const steps = [
    { id: 1, label: "Availability", completed: step > 1, active: step === 1 },
    { id: 2, label: "Details", completed: step > 2, active: step === 2 },
    { id: 3, label: "Summary", completed: false, active: step === 3 },
  ];

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <div className="page-header page-top-icons">
          <div className="row align-items-center">
            <div className="col-md-4">
              <h3 className="page-title">Guest Reservation</h3>
            </div>
            <div className="col-md-8 text-end">
              <div className="view-icons d-flex align-items-center justify-content-end">
                <StepsHeader steps={steps} />
                <Link
                  to="#"
                  className="list-view btn btn-link"
                  id="collapse-header"
                  ref={maximizeBtnRef}
                >
                  <i className="las la-expand-arrows-alt" />
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Steps Content */}
        {step === 1 && (
          <StepAvailability
            selectedRooms={selectedRooms}
            setSelectedRooms={setSelectedRooms}
            searchState={searchState}
            setSearchState={setSearchState}
            filteredRooms={filteredRooms}
            setFilteredRooms={setFilteredRooms}
            handleNext={(billingSummary, selectedRoomsData, updatedSearchState) => {
              setSelectedRooms([...selectedRoomsData]);
              setSearchState(updatedSearchState);
              setPaymentSummary(billingSummary);

              console.log("✅ Saving billing summary before navigating:", billingSummary);
              localStorage.setItem("billingSummary", JSON.stringify(billingSummary));
              localStorage.setItem("selectedRooms", JSON.stringify(selectedRoomsData));

              setStep(2);
            }}
          />
        )}

        {step === 2 && (
          <StepBookingDetails
            guestDetails={guestDetails}
            setGuestDetails={setGuestDetails}
            selectedRooms={selectedRooms}
            setSelectedRooms={setSelectedRooms}
            checkInDate={searchState.checkInDate}
            checkOutDate={searchState.checkOutDate}
            searchState={searchState}
            setSearchState={setSearchState}
            paymentSummary={paymentSummary}
            handleBack={() => {
              localStorage.setItem("searchState", JSON.stringify(searchState));
              setStep(1);
            }}
            handleNext={(data) => {
              setGuestDetails(data.guestInfo);
              setSelectedRooms([...data.selectedRooms]);
              setPaymentSummary(data.paymentSummary);
              setSearchState((prev) => ({
                ...prev,
                checkInDate: data.finalcheckInDate,
                checkOutDate: data.finalcheckOutDate,
              }));
              setStep(3);
            }}
          />
        )}

        {step === 3 && (
          <StepSummary
            selectedRooms={selectedRooms}
            guestDetails={guestDetails}
            finalcheckInDate={searchState.checkInDate} // Use searchState instead of local state
            finalcheckOutDate={searchState.checkOutDate} // Use searchState instead of local state
            paymentSummary={paymentSummary}
            handleBack={() => setStep(2)}
          />
        )}
      </div>
    </div>
  );
};

export default ReservationPage;